// extracted by mini-css-extract-plugin
module.exports = {"content":"order-details_content__3oyjg","done":"order-details_done__1ZCH5","orderNumber":"order-details_orderNumber__7RKjN"};